import { addHandlers, addProps, addState, flowMax } from 'ad-hok'
import { isFunction } from 'lodash/fp'

import { addLocation, addUpdateCurrentHistoryEntry } from './addNavigate'

type AddNavigationStateType = typeof addState

export const addNavigationState: AddNavigationStateType = (
  stateName,
  stateUpdaterName,
  initialState
) =>
  flowMax(
    addLocation,
    addProps(({ location }) => ({
      locationState: (location.state ?? {}) as Record<string, any>,
    })),
    addProps(({ locationState, ...props }) => ({
      [stateName]:
        locationState[stateName] === undefined
          ? isFunction(initialState)
            ? initialState(props as any)
            : initialState
          : locationState[stateName],
    })),
    addUpdateCurrentHistoryEntry,
    addHandlers(
      {
        [stateUpdaterName]:
          ({ updateCurrentHistoryEntry }) =>
          (newState: any) => {
            updateCurrentHistoryEntry({
              additionalState: {
                [stateName]: newState,
              },
            })
          },
      },
      ['updateCurrentHistoryEntry']
    )
  ) as any
